import React, { useState } from 'react'
import {
  List,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip,
  ListItemButton,
  useTheme
} from '@mui/material'

import WbSunnyTwoToneIcon from '@mui/icons-material/WbSunnyTwoTone'
import SettingsSuggestTwoToneIcon from '@mui/icons-material/SettingsSuggestTwoTone'
import AssignmentTurnedInTwoToneIcon from '@mui/icons-material/AssignmentTurnedInTwoTone'
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'

import { useNavigate, useLocation } from 'react-router-dom'

import { useSelector } from 'react-redux'

export const DynamicLighting = () => {
  const { pathname } = useLocation()
  const theme = useTheme()
  const contractData = useSelector(state => state.contracts?.activeContract?.cm_adaptative)
  const isDynamicLightingEnabled = contractData === 1; // Verifica si la iluminación dinámica está habilitada

  const [open, setOpen] = useState(
    pathname.indexOf('/dynamic-lighting') !== -1
  )

  const navigate = useNavigate()


  const handleClick = () => {
    setOpen(!open)
  }

  const handleRoute = route => {
    navigate(route)
  }

  return (
    <>
      {isDynamicLightingEnabled &&
        <List
          component='nav'
          aria-labelledby='nested-list-subheader'
          style={{
            width: '100%',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Tooltip title={'DynLight'} placement='right' arrow>
            <ListItemButton onClick={handleClick}>
              <ListItemIcon>
                <WbSunnyTwoToneIcon />
              </ListItemIcon>
              <ListItemText primary={'DynLight'} />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </Tooltip>

          <Collapse in={open} timeout='auto' unmountOnExit>
            <List component='div' disablePadding dense={true}>

              <Tooltip title={'Perfiles dinámicos'} placement='right' arrow>
                <ListItemButton
                  onClick={() => {
                    handleRoute('/dynamic-lighting/profiles')
                    console.log('Navigating to /dynamic-lighting/profiles')
                  }}
                  selected={pathname.indexOf('/dynamic-lighting/profiles') !== -1}
                  style={{ paddingLeft: theme.spacing(4) }}
                >
                  <ListItemIcon>
                    <AssignmentTurnedInTwoToneIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Perfiles dinámicos'} />
                </ListItemButton>
              </Tooltip>

              <Tooltip title={'Configuración'} placement='right' arrow>
                <ListItemButton
                  onClick={() => handleRoute('/dynamic-lighting/configuration')}
                  selected={pathname.indexOf('/dynamic-lighting/configuration') !== -1}
                  style={{ paddingLeft: theme.spacing(4) }}
                >
                  <ListItemIcon>
                    <SettingsSuggestTwoToneIcon />
                  </ListItemIcon>
                  <ListItemText primary={'Configuración'} />
                </ListItemButton>
              </Tooltip>

            </List>
          </Collapse>
        </List>
      }
    </>
  )
}